import React from "react";
import vison1 from "../../Images/vision.png";
import vison2 from "../../Images/milestones.png";
import vison3 from "../../Images/goal.png";

const VisionMissionGoal = () => {
  return (
    <div className="w-full py-32">
      {/* Cards Container */}
      <div className="container mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row justify-center items-stretch gap-8 lg:gap-6 max-w-6xl mx-auto">
          {/* Vision Card */}
          <div
            className="bg-[#F3F3F3] rounded-3xl p-8 flex-1 shadow-lg hover:shadow-2xl hover:bg-gradient-to-br hover:from-[#C99C48] hover:to-amber-50 transition-all duration-500 transform hover:-translate-y-2 hover:scale-105 group border-2 border-transparent hover:border-[#C99C48]"
            data-aos="fade-up"
            data-aos-duration="600"
          >
            <div className="text-center">
              {/* Icon Container */}
              <div className="w-[170px] h-[170px] bg-[#EDEDED] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-gradient-to-br group-hover:from-yellow-100 group-hover:to-amber-100 transition-all duration-500 group-hover:shadow-lg group-hover:border-2 group-hover:border-yellow-300/50">
                <img
                  src={vison1}
                  alt="Vision Icon"
                  className="w-[100px] h-[100px] transition-all duration-500 group-hover:brightness-0 group-hover:saturate-100"
                  style={{
                    filter: "contrast(1)",
                    transition: "filter 0.5s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.filter =
                      "brightness(0) saturate(100%) invert(84%) sepia(41%) saturate(644%) hue-rotate(348deg) brightness(90%) contrast(86%)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.filter = "contrast(1)";
                  }}
                />
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-800 mb-6 group-hover:text-yellow-600 transition-colors duration-500">
                Vision
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-sm leading-relaxed group-hover:text-yellow-700 transition-colors duration-500">
              To be a leading Saudi holding platform enabling impactful PPP collaborations that drive economic diversification and national development.
              </p>
            </div>
          </div>

          {/* Mission Card */}
          <div
            className="bg-[#F3F3F3] rounded-3xl p-8 flex-1 shadow-lg hover:shadow-2xl hover:bg-gradient-to-br hover:from-[#C99C48] hover:to-amber-50 transition-all duration-500 transform hover:-translate-y-2 hover:scale-105 group border-2 border-transparent hover:border-[#C99C48]"
            data-aos="fade-up"
            data-aos-duration="800"
          >
            <div className="text-center">
              {/* Icon Container */}
              <div className="w-[170px] h-[170px] bg-[#EDEDED] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-gradient-to-br group-hover:from-yellow-100 group-hover:to-amber-100 transition-all duration-500 group-hover:shadow-lg group-hover:border-2 group-hover:border-yellow-300/50">
                <img
                  src={vison2}
                  alt="Mission Icon"
                  className="w-[100px] h-[100px] transition-all duration-500 group-hover:brightness-0 group-hover:saturate-100"
                  style={{
                    filter: "contrast(1)",
                    transition: "filter 0.5s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.filter =
                      "brightness(0) saturate(100%) invert(84%) sepia(41%) saturate(644%) hue-rotate(348deg) brightness(90%) contrast(86%)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.filter = "contrast(1)";
                  }}
                />
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-800 mb-6 group-hover:text-yellow-600 transition-colors duration-500">
                Mission
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-sm leading-relaxed group-hover:text-yellow-700 transition-colors duration-500">
              To empower international clients with strategic guidance, regional insights, and 
              operational excellence that drive enduring success in the Kingdom
              </p>
            </div>
          </div>

          {/* Goal Card */}
          <div
            className="bg-[#F3F3F3] rounded-3xl p-8 flex-1 shadow-lg hover:shadow-2xl hover:bg-gradient-to-br hover:from-[#C99C48] hover:to-amber-50 transition-all duration-500 transform hover:-translate-y-2 hover:scale-105 group border-2 border-transparent hover:border-[#C99C48]"
            data-aos="fade-up"
            data-aos-duration="1200"
          >
            <div className="text-center">
              {/* Icon Container */}
              <div className="w-[170px] h-[170px] bg-[#EDEDED] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-gradient-to-br group-hover:from-yellow-100 group-hover:to-amber-100 transition-all duration-500 group-hover:shadow-lg group-hover:border-2 group-hover:border-yellow-300/50">
                <img
                  src={vison3}
                  alt="Goal Icon"
                  className="w-[100px] h-[100px] transition-all duration-500 group-hover:brightness-0 group-hover:saturate-100"
                  style={{
                    filter: "contrast(1)",
                    transition: "filter 0.5s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.filter =
                      "brightness(0) saturate(100%) invert(84%) sepia(41%) saturate(644%) hue-rotate(348deg) brightness(90%) contrast(86%)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.filter = "contrast(1)";
                  }}
                />
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-800 mb-6 group-hover:text-yellow-600 transition-colors duration-500">
                Goal
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-sm leading-relaxed group-hover:text-yellow-700 transition-colors duration-500">
              Advance foreign direct investment in Vision 2030 sectors 
              <br />
              Strengthen Saudi-international trade corridors
              <br />
              Facilitate sustainable innovation, localization, and knowledge exchange
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisionMissionGoal;
